resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function TextField () {
  // This class also acts as a base class for TextArea
  this.extends = [_Input, _ResponsiveLayout];
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.deleteIcon = null;
  this.placeholderNode = null;
  this.containerDiv = null;
  this.inputContainerDiv = null;

  this.placeholder = '';
  this.placeholderOutside = false;
  this.disabled = false;
  this.error = '';
  this.type = 'text';
  this.locale = null;
  this.mask = '';
  this.maskMoney = '$999999';
  this.maskParams = {};
  this.readonly = false;

  this.init = function () {
    this.containerDiv = $("<div class='mogo-ui-textfield'></div>").insertBefore(this.node)[0];
    this.deleteIcon = $("<a class='icon-crosscir textfield' href='#' tabindex='-1'></a>")[0];
    this.inputContainerDiv = $("<div class='input-container'></div>")[0];
    $(this.node).appendTo(this.inputContainerDiv);
    $(this.inputContainerDiv).appendTo(this.containerDiv);
    $(this.deleteIcon).appendTo(this.inputContainerDiv);

    if ($(this.node).attr('readonly') === 'readonly') {
      this.readonly = true;
    }

    if ($(this.node).attr('placeholder') != null) {
      if (this.placeholder == '') this.placeholder = $(this.node).attr('placeholder');
      $(this.node).attr('placeholder', '');
    }
    if (this.placeholder != '') {
      if (this.placeholderOutside) {
        this.placeholderNode = $("<label for='" + this.id + "'>" + this.placeholder + '</label>');
      } else {
        this.placeholderNode = $(
          "<label class='inner' for='" + this.id + "'>" + this.placeholder + '</label>'
        );
      }
      $(this.placeholderNode).prependTo(this.containerDiv);
    }

    $(this.node).attr('type', this.type);
    if (this.disabled || this.node.disabled) {
      this.disabled = true;
      $(this.containerDiv).addClass('disabled');
      $(this.node).attr('disabled', 'disabled');
    }

    $(this.deleteIcon).on('click', $.proxy(this.onClickDelete, this));
    $(this.placeholderNode).on(
      'click',
      $.proxy(function () {
        $(this.node.focus());
      }, this)
    );
    $(this.node).on('keyup input paste change placeholder', $.proxy(this.onKeyUp, this));
    $(this.node).on('focus', $.proxy(this.onFocus, this));
    $(this.node).on('blur', $.proxy(this.onBlur, this));
    if ($('html.touch').length == 0 && !this.disabled) {
      $(this.containerDiv).on('mouseover', $.proxy(this.onMouseOver, this));
      $(this.containerDiv).on('mouseout', $.proxy(this.onMouseOut, this));
    }

    $(this.node).css('display', 'block');
    setTimeout(
      $.proxy(function () {
        $(this.node).css('background-color', '');
      }, this),
      500
    );

    $(this.node).removeClass('string');
    $(this.node).removeClass('optional');

    if ($(this.node).attr('data-mogo-ui-type') === 'Password-Validator') {
      $(this.node).attr('type', 'Password');

      const _locale = ($(this.node).attr('data-mogo-ui-locale') !== '') ? $(this.node).attr('data-mogo-ui-locale') : null;
      this._passwordValidator(_locale);

      this.registerResponsiveFunction(this.displayPasswordValidator, null, null);
    }

    if (
      $(this.node)
        .attr('type')
        .toLowerCase() == 'password'
    ) {
      this.setupPasswordToggleLink();
    }

    this._super();
  };

  this.val = function (value) {
    if (value != null) {
      $(this.node).val(value);
      $(this.node).trigger('placeholder');
    } else {
      if (this.type == 'email') {
        return $(this.node)
          .val()
          .trim();
      }
      return $(this.node).val();
    }
  };

  this.initAllReady = function () {
    this.onKeyUp();

    if (this.mask != '') {
      this['_setupMask_' + this.mask]();
    }
  };

  this.onClickDelete = function () {
    $(this.node).val('');
    $(this.node).trigger('change');
    $(this.node).trigger('placeholder');
    this.onKeyUp();
    $(this.node).focus();
    return false;
  };

  this.onKeyUp = function () {
    if ($(this.node).val() == '') {
      if (!this.readonly) {
        $(this.deleteIcon).fadeOut(80);
        if (this.maskIcon != null) $(this.maskIcon).fadeIn(80);
      }
      if (!this.placeholderOutside) {
        /*
                     TODO: placeholder should not fade out if there is a mask. Placeholder fading
                     out for a mask such as money mask should be delegated in the mask's
                     implementation, eg. _setupMask_[mask].
                */
        if (this.mask != '' && this.mask != 'cal' && $(this.containerDiv).hasClass('focused')) {
          $(this.placeholderNode).fadeOut(80);
        } else {
          $(this.placeholderNode).fadeIn(80);
        }
      }
    } else {
      if (!this.readonly) {
        if ($(this.containerDiv).hasClass('focused')) {
          $(this.deleteIcon).fadeIn(80);
          if (this.maskIcon != null) $(this.maskIcon).fadeOut(80);
        } else {
          $(this.deleteIcon).fadeOut(80);
          if (this.maskIcon != null) $(this.maskIcon).fadeIn(80);
        }
      }

      if (!this.placeholderOutside) $(this.placeholderNode).fadeOut(80);
    }
  };

  this.onFocus = function () {
    if ($('html.touch').length > 0) $('#portal_nav, #marketing_nav').css('display', 'none');
    $(this.containerDiv).addClass('focused');
    this.onKeyUp();
  };

  this.onBlur = function () {
    if ($('html.touch').length > 0) $('#portal_nav, #marketing_nav').css('display', 'block');
    $(this.containerDiv).removeClass('focused');
    setTimeout($.proxy(this.onKeyUp, this), 50);
  };

  this.onMouseOver = function (evt) {
    if (!$(this.containerDiv).hasClass('focused') && this.node.value != '' && !this.readonly) {
      $(this.deleteIcon).fadeIn(80);
      if (this.maskIcon != null) $(this.maskIcon).fadeOut(80);
    }
  };

  this.onMouseOut = function (evt) {
    if ($(this.containerDiv).has(evt.relatedTarget).length > 0) return;
    if (!$(this.containerDiv).hasClass('focused') && !this.readonly) {
      $(this.deleteIcon).fadeOut(80);
      if (this.maskIcon != null) $(this.maskIcon).fadeIn(80);
    }
  };

  this._setupMask_date = function () {
    if (!$('.ie').length && navigator.userAgent.indexOf('Android') < 0) {
      $(this.node).inputmask('mask', {
        mask: 'y/m/d',
        placeholder: 'YYYY/MM/DD',
        showMaskOnHover: false
      });
    } else {
      $(this.node)
        .attr('maxlength', 10)
        .on(
          'blur',
          $.proxy(function () {
            var date = $(this.node).val();

            for (i = 0; i < date.length; i++) {
              if (i == 3) {
                if (date.charAt(i + 1) !== '/') {
                  var year = [date.slice(0, i + 1), '/', date.slice(i + 1)].join('');
                  $(this.node).val(year);
                  date = $(this.node).val();
                }
              }
              if (i == 6) {
                if (date.charAt(i + 1) !== '/') {
                  var month = [date.slice(0, i + 1), '/', date.slice(i + 1)].join('');
                  $(this.node).val(month);
                }
              }
            }
            $(this.node).trigger('change');
          }, this)
        );
      $(
        '<p class="small" style="margin: 8px 0 0 0">Date of birth format: YYYY/MM/DD</p>'
      ).insertAfter(this.containerDiv);
    }
  };

  this._setupMask_phone = function () {
    $(this.node).inputmask('mask', {
      mask: '(999) 999-9999',
      placeholder: '  ',
      showMaskOnHover: false
    });
  };

  this._setupMask_money = function () {
    if (navigator.userAgent.indexOf('Android') < 0) {
      $(this.node).inputmask('mask', {
        mask: this.maskMoney,
        placeholder: ' ',
        showMaskOnHover: false,
        numericInput: true,
        rightAlignNumerics: false
      });
    } else {
      $(this.node).on(
        'blur',
        $.proxy(function () {
          var num = $(this.node).val();
          num = num.replace('$', '');
          num = parseFloat(num).toFixed(0);
          if (num != NaN && num != 'NaN') {
            num = '$' + num;
            $(this.node)
              .mogo()
              .val(num);
          }
        }, this)
      );
    }
  };

  this._getNodeSpace = function () {
    // Returns space below/above node
    var nodeHeight = $(this.node).outerHeight();
    var topLocation = $(this.node).offset().top - $(window).scrollTop();
    var bottomLocation = topLocation + nodeHeight;
    var windowHeight = $(window).outerHeight();
    var bottomHeightAllowed = windowHeight - bottomLocation; // 20px for padding
    var topHeightAllowed = topLocation;
    return {top: topHeightAllowed, bottom: bottomHeightAllowed};
  };

  this._setupMask_cal = function () {
    this.activeRange();

    // Add specially formated display label
    this.formattedDisplayDay = $(
      '<label for=' +
        this.id +
        ' class="inner birthday-date-format js-formatted-box" style="color: #000;"></label>'
    );
    $(this.formattedDisplayDay).prependTo(this.containerDiv);

    var field = $(this.node);
    var inputContainer = field.parents('.input-container');
    var mogoTextfield = inputContainer.parents('.mogo-ui-textfield');
    var deleteIcon = inputContainer.find('.icon-crosscir');
    var formattedDisplayLabel = mogoTextfield.find('.js-formatted-box');

    this._harvestComponentParams('calendar');

    // Create calendar with parameters
    this.maskParams.id = this.id + '_calendar';
    this.maskParams.onSelectionCallback = $.proxy(function () {
      this.val(
        $('#' + this.id + '_calendar')
          .mogo()
          .val()
          .replace(/-/g, '/')
      );
      $(this.node).trigger('change');
      $(document).unbind('click', this._documentListener);
      $('.film', this.containerDiv).fadeOut(325);
      $('#' + this.id + '_calendar').fadeOut(325);

      // Disable Calendar functionality and focus back on the textfield
      // [#127602585] On IE the focus event is triggered after the callback.
      // hence we need to disable the calendar functionality and re-add it back after focus
      $(this.node).off('focus'); // disable focus handlers
      $(this.node).on(
        'focus',
        $.proxy(function () {
          $(this.node).off('focus'); // on focus clear again so we can re-add calendar functionality
          $(this.node).on('focus', this._focusClick);
        }, this)
      );

      $(this.node).focus();
      var calDateVal = $('#' + this.id + '_calendar').mogo()._curFocused;
      var d = moment(calDateVal).format('MMMM D, YYYY');
      formattedDisplayLabel.text(d);
      $(this.node).css('color', '#fff'); // hide the text because...
    }, this);

    // Create Calendar Component:
    $("<div class='init'></div>")
      .appendTo(this.containerDiv)
      .mogo()
      .create('Calendar', this.maskParams);
    $("<div class='film'></div>").appendTo(this.containerDiv);

    // Set up variables
    this._documentListener = $.proxy(function (e) {
      e.stopImmediatePropagation();
      if (!$.contains(this.containerDiv, e.target)) {
        $(document).unbind('click', this._documentListener);
        $('.film', this.containerDiv).fadeOut(325);
        $('#' + this.id + '_calendar').fadeOut(325);
        $('#' + this.id + '_calendar')
          .mogo()
          .resetCalViews();
      }
    }, this);

    // Add calendar icon
    this.maskIcon = $(
      '<svg viewBox="0 0 32 35" class="svg-icon calendar" focusable="false"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-calendar"></use></svg>'
    );
    $(this.maskIcon).appendTo(this.inputContainerDiv);

    // Connections

    // Mask icon click
    $(this.maskIcon).on(
      'click',
      $.proxy(function () {
        $(this.node).focus();
        return false;
      }, this)
    );

    // Delete click (clear Formated Label)
    deleteIcon.on('click', function () {
      formattedDisplayLabel.text('');
    });

    // On textfield focus
    this._focusClick = $.proxy(function (e) {
      // e.stopImmediatePropagation();
      if (this._state == -1) this.showErrorLabel();

      var calNode = $('#' + this.id + '_calendar');
      if ($(calNode).hasClass('init')) {
        $(calNode).css('display', 'none');
        $(calNode).removeClass('init');
      }
      if (!this.smallRange) {
        if (this._getNodeSpace().bottom > 345) {
          // Place under
          $(calNode).css('top', '47px');
          $(calNode).css('bottom', 'auto');
        } else if (this._getNodeSpace().top > 345) {
          // Place
          $(calNode).css('bottom', '47px');
          $(calNode).css('top', 'auto');
        } else {
          // Place under
          $(calNode).css('top', '47px');
          $(calNode).css('bottom', 'auto');
        }
      }
      $('.film', this.containerDiv).fadeIn(325);
      $(calNode).fadeIn(325);
      // HACK on iOS fixed position doesn't work while focused on text elements
      // so switch to focus on the calendar element
      if ($('html.touch').length > 0) $(calNode).focus();

      $(document).bind('click', this._documentListener);
    }, this);

    // $(this.node).on("focus", focusClick); Breaks onSelection in Win7 IE.
    $(this.node).on('click', this._focusClick);
    // iOS mobile fix to allow re-focus on a focused element
    $(this.node).on(
      'touchstart',
      $.proxy(function () {
        setTimeout(this._focusClick, 325);
      }, this)
    );

    // Update calendar from text field
    $(this.node).on(
      'keyup input paste change placeholder',
      $.proxy(function () {
        $('#' + this.id + '_calendar')
          .mogo()
          .val(
            $(this.node)
              .mogo()
              .val()
              .replace(/\//g, '-')
          );
        if (
          $('#' + this.id + '_calendar')
            .mogo()
            .val()
            .replace(/-/g, '/') == $(this.node).val()
        ) {
          this.hideError();
          this.setError(true);
        }
      }, this)
    );

    // Check for invalid entries
    $(this.node).on(
      'blur',
      $.proxy(function (e) {
        if (
          $('#' + this.id + '_calendar')
            .mogo()
            .val()
            .replace(/-/g, '/') != $(this.node).val()
        ) {
          this.setError(true, 'Please enter a valid date.');
          this.showError();
          this.hideErrorLabel();
          $('#' + this.id + '_calendar')
            .mogo()
            .val('');
          $(this.node).trigger('change');
        } else {
          this.hideError();
          this.setError(true);
        }
      }, this)
    );

    // Blur close
    var blurClose = $.proxy(function (e) {
      setTimeout(
        $.proxy(function () {
          if (!$.contains(this.containerDiv, document.activeElement)) {
            $(document).unbind('click', this._documentListener);
            $('.film', this.containerDiv).fadeOut(325);
            $('#' + this.id + '_calendar').fadeOut(325);
          }
        }, this),
        100
      );
    }, this);
    // $(this.node).on("blur", blurClose); // I don't believe we need this in fact it hides the cal popup when we still are using it.
    $($('.init', this.containerDiv)[0]).on('calBlur', blurClose);

    // Add keyboard accessibility
    $(this.node).on(
      'keydown',
      $.proxy(function (e) {
        if (e.which == 13) {
          e.preventDefault();
          // Enter Key
          if ($('#' + this.id + '_calendar').css('display') != 'none') {
            $(document).unbind('click', this._documentListener);
            $('.film', this.containerDiv).fadeOut(325);
            $('#' + this.id + '_calendar').fadeOut(325);
          } else {
            var calNode = $('#' + this.id + '_calendar');
            if (!this.smallRange) {
              if (this._getNodeSpace().bottom > 345) {
                // Place under
                $(calNode).css('top', '47px');
                $(calNode).css('bottom', 'auto');
              } else if (this._getNodeSpace().top > 345) {
                // Place
                $(calNode).css('bottom', '47px');
                $(calNode).css('top', 'auto');
              } else {
                // Place under
                $(calNode).css('top', '47px');
                $(calNode).css('bottom', 'auto');
              }
            }
            $('.film', this.containerDiv).fadeIn(325);
            $(calNode).fadeIn(325);
            $(document).bind('click', this._documentListener);
          }
        } else if (e.which == 27) {
          // ESC key
          e.preventDefault();
          $(document).unbind('click', this._documentListener);
          $('.film', this.containerDiv).fadeOut(325);
          $('#' + this.id + '_calendar').fadeOut(325);
        }
      }, this)
    );
  };

  this._harvestComponentParams = function (string) {
    var stringToCheck = string;
    for (var propertyName in this) {
      var x = propertyName.substr(0, stringToCheck.length);
      if (x == stringToCheck) {
        var p = propertyName.substr(stringToCheck.length, propertyName.length - 1);
        p = p.substr(0, 1).toLowerCase() + p.substr(1, p.length);
        this.maskParams[p] = this[propertyName];
      }
    }
  };

  this.displayPasswordValidator = function (width) {
    if (width < window.mogo.registry.mogoUI.config.mediaQueries.small) {
      $('#password-validator').hide();
    } else {
      $('#password-validator').show();
    }
  };

  this._passwordValidator = function (locale) {
    var iconTicker =
      "<svg class='svg-icon icon__svgticker' viewbox='0 0 39 32'><use xlink:href='#icon-ticker'></use></svg>";
    iconCircleClose =
      "<svg class='svg-icon icon__svgcircle-cross' viewbox='0 0 39 32'><use xlink:href='#icon-circle-close'></use></svg>";
    var character = {
      letter: /[a-zA-Zéàèùçâêîôûëöüœ]/,
      number: /[-0-9]+/,
      symbol: /[!@#$%^&(*)_]+/,
      length: 8
    };
    const textAtLeast = (locale === 'fr-CA') ? 'Votre mot de passe doit être composé de' : 'Your password must include at least:';
    const textCharacters = (locale === 'fr-CA') ? ' caractères' : ' characters';
    const textOneLetter = (locale === 'fr-CA') ? '1 lettre' : '1 letter';
    const textNumberOrSymbol = (locale === 'fr-CA') ? '1 numéro / symbole' : '1 number or symbol';

    $(this.node)
      .closest('.row')
      .append(
        '<div id="password-validator" class="row">' +
          '<ul class="small-12 columns"><li>' +
          textAtLeast +
          '</li>' +
          '<li class="point" id="valid-charCount">' +
          iconCircleClose +
          iconTicker +
          character.length +
          textCharacters +
          '</li>' +
          '<li class="point" id="valid-letter">' +
          iconCircleClose +
          iconTicker +
          textOneLetter +
          '</li>' +
          '<li class="point" id="valid-numSym">' +
          iconCircleClose +
          iconTicker +
          textNumberOrSymbol +
          '</li></ul></div>'
      );
    var field = $(this.node);
    var visualValidator = $('#password-validator');
    var deleteIcon = field.parents('.input-container').find('.icon-crosscir');
    var validate = {
      letter: function (node) {
        if (node.val().match(character.letter)) {
          $('#valid-letter')
            .removeClass('point')
            .addClass('check');
        } else {
          $('#valid-letter')
            .removeClass('check')
            .addClass('point');
        }
      },
      number: function (node) {
        if (node.val().match(character.number)) {
          $('#valid-numSym')
            .removeClass('point')
            .addClass('check');
        } else {
          if (!node.val().match(character.symbol)) {
            $('#valid-numSym')
              .removeClass('check')
              .addClass('point');
          }
        }
      },
      symbol: function (node) {
        if (node.val().match(character.symbol)) {
          $('#valid-numSym')
            .removeClass('point')
            .addClass('check');
        } else {
          if (!node.val().match(character.number)) {
            $('#valid-numSym')
              .removeClass('check')
              .addClass('point');
          }
        }
      },
      length: function (node) {
        if (node.val().length >= character.length) {
          $('#valid-charCount')
            .removeClass('point')
            .addClass('check');
        } else {
          $('#valid-charCount')
            .removeClass('check')
            .addClass('point');
        }
      },
      all: function (node) {
        this.letter(node);
        this.number(node);
        this.symbol(node);
        this.length(node);
      }
    };

    field.on('keyup', function () {
      var node = $(this);
      validate.all(node);
    });
    field.on('focus', function () {
      visualValidator.addClass('focused');
      if (
        $(window).width() < mogo.registry.mogoUI.config.mediaQueries.small &&
        !visualValidator.is(':animated')
      ) {
        visualValidator.slideDown();
      }
    });
    field.on('blur', function () {
      if (field.val() == '') {
        visualValidator.removeClass('focused');
      }
      if (
        $(window).width() < mogo.registry.mogoUI.config.mediaQueries.small &&
        !visualValidator.is(':animated')
      ) {
        visualValidator.slideUp();
      }
    });
    deleteIcon.on('click', function () {
      validate.all($(this));
    });
  };
  this.setupPasswordToggleLink = function () {
    // Append show icon at the start of the page.
    this._iconPasswordShow =
      "<svg class='svg-icon svg-icon--show' viewbox='0 0 32 32'><use xlink:href='#icon-password-show'></use></svg>";
    this._iconPasswordHide =
      "<svg class='svg-icon svg-icon--hide' viewbox='0 0 32 32'><use xlink:href='#icon-password-hide'></use></svg>";

    var a = document.createElement('a');
    a.setAttribute('title', 'toggle-password');
    a.setAttribute('class', 'toggle-password');
    a.innerHTML = 'Show password' + this._iconPasswordShow;
    $(this.node.parentElement).append(a);
    $(this.node.parentElement)
      .find('.toggle-password')
      .on('click', this.togglePassword.bind(this));
  };
  this.togglePassword = function (event) {
    event.preventDefault();
    event.stopPropagation();

    var field = $(event.currentTarget.parentNode).find('input'),
      type = field.attr('type').toLowerCase();

    $(event.target).toggleClass('js-hide-password');

    // depending on the type, the inner html shows different icons
    if (type === 'password') {
      field.attr('type', 'text');
      event.currentTarget.innerHTML = 'Hide password' + this._iconPasswordHide;
    } else {
      field.attr('type', 'password');
      event.currentTarget.innerHTML = 'Show password' + this._iconPasswordShow;
    }
  };
}
